var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06401 1.5C4.06401 1.22386 4.28787 1 4.56401 1H5.13894C5.41508 1 5.63894 1.22386 5.63894 1.5V2.18493H10.3637V1.5C10.3637 1.22386 10.5876 1 10.8637 1H11.4386C11.7148 1 11.9386 1.22386 11.9386 1.5V2.18493H12.2026C13.749 2.18493 15.0026 3.43854 15.0026 4.98493V12.1997C15.0026 13.7461 13.749 14.9997 12.2026 14.9997H3.8C2.25361 14.9997 1 13.7461 1 12.1997V4.98494C1 3.43854 2.25361 2.18493 3.8 2.18493H4.06401V1.5ZM2.6 12.1997V5.86212H13.4026V12.1997C13.4026 12.8625 12.8653 13.3997 12.2026 13.3997H3.8C3.13726 13.3997 2.6 12.8625 2.6 12.1997ZM9.19035 9.33667C8.91421 9.33667 8.69035 9.56053 8.69035 9.83667V11.6146C8.69035 11.8907 8.91421 12.1146 9.19035 12.1146H11.6355C11.9117 12.1146 12.1355 11.8907 12.1355 11.6146V9.83667C12.1355 9.56053 11.9117 9.33667 11.6355 9.33667H9.19035Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bba7ceab2c81eec812d9349982dd15fa.svg";
export { ForwardRef as ReactComponent };